/**
 * @file Jwt Token Headers Add.
 * @author Fatih Arıcılık
 */

/**
 * Add JWT Header APIs
 * @returns New header
 */
export default function AuthService() {
  if (localStorage.getItem("jwtHeader") === null) return null;
  return {
    headers: { Authorization: `Bearer ${localStorage.getItem("jwtHeader")}` },
  };
}
